

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */
/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
/* eslint-disable no-eval */
/* global ActiveXObject, encryptionHandler, encryptionHandler2 */

//warning!! this file is also shared and used inside demo page, see uniwizard-lib.js
//be careful when changing
import $ from 'jquery';
import tools from '../js/tools';
import utils from './utils';

// enumerations copied from SDK\COM\doc with reformatted syntax
var enumEncodingFlag = { // encodingFlag reports what the STU device is capable of:
    EncodingFlag_Zlib: 0x01,
    EncodingFlag_1bit: 0x02, // mono
    EncodingFlag_16bit: 0x04, // 16bit colour (520/530)
    EncodingFlag_24bit: 0x08, // 24bit colour (530)
};

var enumEncodingMode = { // selects image transformation
    EncodingMode_1bit: 0x00, // mono display STU300/430/500
    EncodingMode_1bit_Zlib: 0x01, // use zlib compression (not automated by the SDK – the application code has to compress the data)
    EncodingMode_16bit: 0x02, // colour stu-520 & 530
    EncodingMode_24bit: 0x04, // colour STU 530
    // tablet.supportsWrite() is true if the bulk driver is installed and available
    EncodingMode_1bit_Bulk: 0x10, // use bulk driver (520/530)
    EncodingMode_16bit_Bulk: 0x12,
    EncodingMode_24bit_Bulk: 0x14,

    EncodingMode_Raw: 0x00,
    EncodingMode_Zlib: 0x01,
    EncodingMode_Bulk: 0x10,
    EncodingMode_16bit_565: 0x02,
};
var enumScale = {
    Scale_Stretch: 0,
    Scale_Fit: 1,
    Scale_Clip: 2,
};
var enumProductId = {
    STU_500: 0xa1,
    STU_300: 0xa2,
    STU_520: 0xa3,
    STU_430: 0xa4,
    STU_530: 0xa5,
};
var enumPenDataOptionMode = {
    PenDataOptionMode_None: 0,
    PenDataOptionMode_TimeCount: 1,
    PenDataOptionMode_SequenceNumber: 2,
    PenDataOptionMode_TimeCountSequence: 3,
};

function WacomHandler(signer) {
    // Member variables
    var wgssSTU = null; //netscape plugin.
    var m_tablet = null;
    var m_capability = null;
    var m_inkThreshold = null;
    var m_information = null;
    var m_usingEncryption = null;
    var m_timeStampCountingEnabled = null;

    // The isDown flag is used like this:
    // 0 = up
    // +ve = down, pressed on button number
    // -1 = down, inking
    // -2 = down, ignoring
    var m_isDown = null;

    var m_penData = null; // Array of data being stored. This can be subsequently used as desired.
    var m_btns = null; // The array of buttons that we are emulating.
    var m_encodingMode = null; // How we send the bitmap to the device.
    var m_bitmapData = null; // This is the flattened data of the bitmap that we send to the device.
    var m_haveBitmapData = false;
    var m_signer = signer;
    var m_aspect = null;
    //in window coordinates, not in tablet!
    var m_offsetx = null;
    var m_offsety = null;
    var m_width = null;
    var m_height = null;
    var m_usbDevice = null;
    var m_penTimeFirst = null;

    // Detect the browser.
    var m_useActiveX = false;
    try {
        var test = new ActiveXObject('WacomGSS.STU.UsbDevices');
        // If the above hasn't thrown, browser is IE and components are installed
        if(test)
            m_useActiveX = true;
    } catch(ex) {
        // Browser isn't IE or components are not installed, either way we can't use ActiveX
    }

    // Create an object maintaining the compatibility beetween browsers.

    function createObject(objectName) {
        var object;
        if(m_useActiveX) {
            object = new ActiveXObject(objectName);
        } else {
            if(!wgssSTU) {
                wgssSTU = document.getElementById('wgssSTU');
            }
            object = wgssSTU.createObject(objectName);
        }

        return object;
    }

    function tabletToWindow(penData) {
        // Screen means LCD screen of the tablet.
        var screenx = (penData.x * m_capability.screenWidth) / m_capability.tabletMaxX;
        var screeny = (penData.y * m_capability.screenHeight) / m_capability.tabletMaxY;
        return new utils.Point((screenx * m_aspect) - m_offsetx, (screeny * m_aspect) - m_offsety);
    }

    function stringToByteArray(imageString) {
        var imageData = imageString;

        // window.atob is only available in mozilla browsers and IE 10 and above.
        // if you want to use IE 9 there are differents library
        // for doing the same functionality.
        var raw;
        if(window.atob) {
            raw = window.atob(imageData);
        } else {
            //if there is an exception the browser does not support the atob function
            raw = decode64(imageData);
        }

        var rawLength = raw.length;
        var imageArray = new Array(rawLength);

        for(var i = 0; i < rawLength; i++) {
            imageArray[i] = raw.charCodeAt(i);
        }

        var js = new ActiveXObject('WacomGSS.STU.JScript');
        return js.toVBArray(imageArray);
    }

    // Process incoming pen data (STU-430, STU-530)
    function onPenDataTimeCountSequenceEncrypted(penData) {
        processPenData(penData, penData.timeCount);
    }

    function onPenDataTimeCountSequence(penData) {
        processPenData(penData, penData.timeCount);
    }

    // Process incoming pen data (STU-520)
    function onPenDataEncryptedOption(penData) {
        processPenData(penData.penData1, penData.option1);
        processPenData(penData.penData2, penData.option2);
    }

    function onPenDataOption(penData) {
        processPenData(penData, penData.option);
    }

    // Process incoming pen data (STU-300, STU-500)
    // data rate 200 per second = 5ms
    function onPenDataEncrypted(penData) {
        var dt = new Date().getTime();
        if(m_penTimeFirst === null) {
            m_penTimeFirst = dt - 5;
        }
        processPenData(penData.penData1, (dt - 5) - m_penTimeFirst);
        processPenData(penData.penData2, dt - m_penTimeFirst);
    }

    function onPenData(penData) {
        var dt = new Date().getTime();
        if(m_penTimeFirst === null) {
            m_penTimeFirst = dt;
        }
        processPenData(penData, dt - m_penTimeFirst);
    }

    function processPenData(penData, time) {
        if(!penData.rdy)
            return;
        var penDataObj = {
            x: penData.x, y: penData.y, pressure: penData.pressure, time,
        };
        var pt = tabletToWindow(penDataObj);

        var btn = 0; // will be +ve if the pen is over a button.
        for(var i = 0; i < m_btns.length; ++i) {
            if(m_btns[i].bounds.contains(pt)) {
                btn = i + 1;
                break;
            }
        }

        var isDown;
        if(m_isDown == 0) {
            isDown = (penDataObj.pressure > 0);

            if(isDown) {
                // transition to down
                if(btn > 0) {
                    // We have put the pen down on a button.
                    // Track the pen without inking on the client.

                    m_isDown = btn;
                } else {
                    // We have put the pen down somewhere else.
                    // Treat it as part of the signature.

                    m_isDown = -1;
                }
            }

            //we pressed pen outside button, let's capture
            //also capture pen up events, when we already captured some pen downs, as C# BioSign does
            if(((m_isDown == 0) && m_penData.length)
                    || (m_isDown == -1))
                m_penData.push(penDataObj);
        } else {
            isDown = (penDataObj.pressure > 0);

            // draw
            if(m_isDown == -1) {
                // Draw a line from the previous down point to this down point.
                // This is the simplist thing you can do; a more sophisticated program
                // can perform higher quality rendering than this!

                var prev = tabletToWindow(m_penData[m_penData.length - 1]);
                m_signer.onPenData(prev, pt, penDataObj.pressure / m_capability.tabletMaxPressure);
                m_penData.push(penDataObj);
            }

            if(!isDown) {
                // transition to up
                if(btn > 0) {
                    // The pen is over a button

                    if(btn == m_isDown) {
                        // The pen was pressed down over the same button as is was lifted now.
                        // Consider that as a click!
                        setTimeout(function() {
                            m_btns[btn - 1].click();
                        }, 10);
                    }
                }
                m_isDown = 0;
            }
        }
    }

    // Capture any report exception.

    function onGetReportException(exception) {
        try {
            exception.getException();
        } catch(e) {
            tools.scripterr(e);
        }
    }

    // Only necesary for IE9

    function decode64(input) {
        var keyStr = 'ABCDEFGHIJKLMNOP'
            + 'QRSTUVWXYZabcdef'
            + 'ghijklmnopqrstuv'
            + 'wxyz0123456789+/'
            + '=';

        var output = '';
        var chr1;
        var chr2;
        var chr3 = '';
        var enc1;
        var enc2;
        var enc3;
        var enc4 = '';
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        // eslint-disable-next-line no-useless-escape
        var base64test = /[^A-Za-z0-9\+\/\=]/g;

        if(base64test.exec(input)) {
            tools.scripterr('There were invalid base64 characters in the input text.\n'
                + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n"
                + 'Expect errors in decoding.');
        }

        // eslint-disable-next-line no-useless-escape
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        do {
            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output += String.fromCharCode(chr1);

            if(enc3 != 64) {
                output += String.fromCharCode(chr2);
            }

            if(enc4 != 64) {
                output += String.fromCharCode(chr3);
            }

            // eslint-disable-next-line no-multi-assign
            chr1 = chr2 = chr3 = '';
            // eslint-disable-next-line no-multi-assign
            enc1 = enc2 = enc3 = enc4 = '';
        } while(i < input.length);

        return decodeURIComponent(output);
    }

    this.init = function() {
        var usbDevices = createObject('WacomGSS.STU.UsbDevices');
        if(usbDevices.Count <= 0) {
            throw new Error('There is no tablet present');
        }

        m_usbDevice = usbDevices.Item(0);
    };

    // Connect to the first device
    this.connect = function() {
        var self = this;
        m_penTimeFirst = null;
        m_penData = [];
        m_tablet = createObject('WacomGSS.STU.Tablet');

        // A more sophisticated applications should cycle for a few times as the connection may only be
        // temporarily unavailable for a second or so.
        // For example, if a background process such as Wacom STU Display
        // is running, this periodically updates a slideshow of images to the device.
        var encryptionEnabled = false;
        if(typeof (encryptionHandler) != 'undefined') {
            if(m_useActiveX) {
                //encryption is disabled 2014-05-29
                var js = new ActiveXObject('WacomGSS.STU.JScript');
                m_tablet.encryptionHandler = js.toTabletEncryptionHandler(encryptionHandler());
                m_tablet.encryptionHandler2 = js.toTabletEncryptionHandler2(encryptionHandler2());
                encryptionEnabled = true;
            }
        }

        var protocolHelper = createObject('WacomGSS.STU.ProtocolHelper');

        var ec = m_tablet.usbConnect(m_usbDevice, true);
        if(ec.value == 0) {
            m_capability = m_tablet.getCapability();
            m_inkThreshold = m_tablet.getInkThreshold();
            m_information = m_tablet.getInformation();
            m_usingEncryption = false;

            if(encryptionEnabled && (m_tablet.isSupported(0x50) // v2 encryption
                    || protocolHelper.supportsEncryption_DHprime(m_tablet.getDHprime()))) // v1 encryption
                m_usingEncryption = true;
        } else {
            throw new Error(ec.message);
        }

        var idProduct = m_usbDevice.idProduct;
        var encodingFlag = protocolHelper.simulateEncodingFlag(m_tablet.getProductId(), m_capability.encodingFlag);
        // Disable color if the bulk driver isn't installed (supportsWrite())
        if((encodingFlag & enumEncodingFlag.EncodingFlag_24bit) != 0) {
            m_encodingMode = m_tablet.supportsWrite() ? enumEncodingMode.EncodingMode_24bit_Bulk : enumEncodingMode.EncodingMode_24bit;
        } else if((encodingFlag & enumEncodingFlag.EncodingFlag_16bit) != 0) {
            m_encodingMode = m_tablet.supportsWrite() ? enumEncodingMode.EncodingMode_16bit_Bulk : enumEncodingMode.EncodingMode_16bit;
        } else {
            // assumes 1bit is available
            m_encodingMode = enumEncodingMode.EncodingMode_1bit;
        }
        var useColor = false;
        if((m_encodingMode & (enumEncodingMode.EncodingMode_16bit_Bulk | enumEncodingMode.EncodingMode_24bit_Bulk)) != 0)
            useColor = true;

        // Create the signature window.
        // The STU-300 is very shallow, so it is better to utilise
        // the buttons to the side of the display instead.
        var wndData = m_signer.createModalWindow(idProduct != enumProductId.STU_300);
        m_signer.selectDevice(self, utils.FILTER_WACOM);

        m_btns = wndData.btns;
        m_width = wndData.width;
        m_height = wndData.height;
        var aspectx = m_width / m_capability.screenWidth;
        var aspecty = m_height / m_capability.screenHeight;
        m_aspect = Math.max(aspectx, aspecty);
        var imageUrl = wndData.imageUrl;

        //wacom places image on center
        m_offsetx = ((m_capability.screenWidth * m_aspect) - m_width) / 2;
        m_offsety = ((m_capability.screenHeight * m_aspect) - m_height) / 2;
        $.ajax({
            type: 'GET',
            url: imageUrl.construct({ format: 'jpeg', type: 'json', transparent: false }),
            dataType: 'json',
            success(data) {
                if(data.status != 'ok') {
                    return;
                }
                var canvasImage = data.image;

                // This application uses the same bitmap for both the screen and client (window).
                // Now the bitmap has been created, it needs to be converted to device-native
                // format.
                var imageData = stringToByteArray(canvasImage);
                m_bitmapData = protocolHelper.resizeAndFlatten(
                    imageData,
                    0,
                    0,
                    m_width,
                    m_height,
                    m_capability.screenWidth,
                    m_capability.screenHeight,
                    m_encodingMode,
                    enumScale.Scale_Fit,
                    false,
                    0,
                );
                m_haveBitmapData = true;
                self.clearScreen();
            },
        });

        // Add the delagate that receives pen data and error.
        var eventMode = 'onPenData';
        if(idProduct == enumProductId.STU_520) {
            m_tablet.setPenDataOptionMode(enumPenDataOptionMode.PenDataOptionMode_TimeCount);
            m_timeStampCountingEnabled = true;
            eventMode = 'onPenDataOption';
        } else if((idProduct == enumProductId.STU_430) || (idProduct == enumProductId.STU_530)) {
            m_tablet.setPenDataOptionMode(enumPenDataOptionMode.PenDataOptionMode_TimeCountSequence);
            m_timeStampCountingEnabled = true;
            eventMode = 'onPenDataTimeCountSequence';
        }
        if(m_useActiveX) {
            switch(eventMode) {
                case 'onPenData':
                    eval('function m_tablet::onPenData(data) {return onPenData(data);}');
                    if(m_usingEncryption)
                        eval('function m_tablet::onPenDataEncrypted(data) {return onPenDataEncrypted(data);}');
                    break;
                case 'onPenDataOption':
                    eval('function m_tablet::onPenDataOption(data) {return onPenDataOption(data);}');
                    if(m_usingEncryption)
                        eval('function m_tablet::onPenDataEncryptedOption(data) {return onPenDataEncryptedOption(data);}');
                    break;
                case 'onPenDataTimeCountSequence':
                    eval('function m_tablet::onPenDataTimeCountSequence(data) {return onPenDataTimeCountSequence(data);}');
                    if(m_usingEncryption)
                        eval('function m_tablet::onPenDataTimeCountSequenceEncrypted(data) {return onPenDataTimeCountSequenceEncrypted(data);}');
                    break;
            }
            eval('function m_tablet::onGetReportException(exception) {return onGetReportException(exception);}');
        } else {
            switch(eventMode) {
                case 'onPenData':
                    m_tablet.onPenData = onPenData;
                    if(m_usingEncryption)
                        m_tablet.onPenDataEncrypted = onPenDataEncrypted;
                    break;
                case 'onPenDataOption':
                    m_tablet.onPenDataOption = onPenDataOption;
                    if(m_usingEncryption)
                        m_tablet.onPenDataEncryptedOption = onPenDataEncryptedOption;
                    break;
                case 'onPenDataTimeCountSequence':
                    m_tablet.onPenDataTimeCountSequence = onPenDataTimeCountSequence;
                    if(m_usingEncryption)
                        m_tablet.onPenDataTimeCountSequenceEncrypted = onPenDataTimeCountSequenceEncrypted;
                    break;
            }
            m_tablet.onGetReportException = onGetReportException;
        }

        try {
            if(m_usingEncryption) {
                m_tablet.startCapture(0xc0ffee);
            }
        } catch(e) {
            m_usingEncryption = false;
        }
        // Enable the pen data on the screen (if not already)
        m_tablet.setInkingMode(0x01);
    };

    // Initialize the screen
    this.clearScreen = function() {
        if(m_haveBitmapData) {
            // note: There is no need to clear the tablet screen prior to writing an image.
            m_tablet.writeImage(m_encodingMode, m_bitmapData);
        }

        m_penTimeFirst = null;
        m_penData = [];
        m_isDown = 0;
    };

    this.close = function() {
        // Ensure that you correctly disconnect from the tablet, otherwise you are
        // likely to get errors when wanting to connect a second time.
        if(m_tablet) {
            m_tablet.setInkingMode(0x00);
            m_tablet.setClearScreen();
            m_tablet.disconnect();
        }
    };

    this.makeSignatureData = function() {
        if(!m_penData || !m_penData.length)
            throw new Error('La firma non è ancora stata raccolta');

        var signatureData = {
            manufacturer: 'Wacom',
            model: m_information.modelName,
            minPenTouchForce: 0,
            xPointMin: 0,
            yPointMin: 0,
            xPointMax: (m_width / m_aspect) * (m_capability.tabletMaxX / m_capability.screenWidth),
            yPointMax: (m_height / m_aspect) * (m_capability.tabletMaxY / m_capability.screenHeight),
            chx: null,
            chy: null,
            chpressure: null,
        };
        // eslint-disable-next-line no-control-regex
        signatureData.model.replace(/^\u0001*/, '');
        // eslint-disable-next-line no-control-regex
        signatureData.model.replace(/\u0001*$/, '');

        // 100 lines per mm (= 2540 lpi)
        var xyPointScale = 100.0;
        // From an e-mail from Mr. Nick Mettyear (Wacom): "The maximum pen pressure level of 512 corresponds to a load of 200 g."
        var pressureScale = 512.0 / (0.2 * 9.81);
        var timeSampleRatePerSecond = 200.0; // 200 pps (points per second)
        var timeScalingValue = 1000.0; // milliseconds
        var timeMinValue = 0;
        var timeMaxValue = 65535;

        var chx = {
            scale: xyPointScale, min: 0, max: m_capability.tabletMaxX, data: [],
        };
        var chy = {
            scale: xyPointScale, min: 0, max: m_capability.tabletMaxY, data: [],
        };
        var chpressure = {
            scale: pressureScale, min: 0, max: m_capability.tabletMaxPressure, data: [],
        };
        var chtime = null;
        if(m_timeStampCountingEnabled) {
            chtime = {
                scale: timeScalingValue, min: timeMinValue, max: timeMaxValue, data: [],
            };
        }

        for(var i = 0; i < m_penData.length; i++) {
            var penPoint = m_penData[i];
            chx.data.push(penPoint.x);
            chy.data.push(penPoint.y);
            chpressure.data.push(penPoint.pressure);
            if(chtime) {
                if(penPoint.time > timeMaxValue)
                    throw new Error('La massima durata di acquisizione della firma è stata superata..');
                chtime.data.push(penPoint.time);
            }
        }

        signatureData.chx = chx;
        signatureData.chy = chy;
        signatureData.chpressure = chpressure;
        if(chtime)
            signatureData.chtime = chtime;
        else
            signatureData.chtd = { scale: timeSampleRatePerSecond };

        return signatureData;
    };
}

export default WacomHandler;
